import React, { useEffect } from 'react';
import { useWishlist } from '../wishlist/WishlistContext';

export default function WishlistNoticeToast() {
  const { notice, dismissNotice } = useWishlist();

  useEffect(() => {
    if (!notice) return undefined;
    const t = window.setTimeout(() => dismissNotice(), 4500);
    return () => window.clearTimeout(t);
  }, [notice, dismissNotice]);

  if (!notice) return null;

  return (
    <div className="cart-added-toast wishlist-notice-toast" role="alert" aria-live="assertive">
      <div className="cart-added-toast__inner">
        <span className="cart-added-toast__check wishlist-notice-toast__icon" aria-hidden>
          !
        </span>
        <div className="cart-added-toast__text">
          <strong className="cart-added-toast__title">{notice}</strong>
        </div>
        <button type="button" className="btn-close cart-added-toast__close" aria-label="Dismiss" onClick={dismissNotice} />
      </div>
    </div>
  );
}
